import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { setBackdropValue, setInputBoxVisibility } from 'store';

const Backdrop = props => {

    const handleClick = () => {
        props.setBackdropValue(false)
        props.setInputBoxVisibility(false);
    }
    const { backdropValue } = props
    
    if(backdropValue === true) {
        return (
            <Wrapper onClick={() => handleClick()}/>
        )
    } else return null;
}

const mapStateToProps = state => ({
    backdropValue: state.backdropValue,
    inputBoxVisibility: state.inputBoxVisibiliy
})

const actions = {
    setBackdropValue,
    setInputBoxVisibility
}

export default connect(mapStateToProps, actions)(Backdrop);

const Wrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    min-height: 100vh;
    height: 100%;
    z-index: 100;
    background-color: transparent;
`